// Bilingual content — Romanian (default) and English
import { articlesEn, articlesRo } from "./articlesContent";

export const translations = {
  ro: {
    nav: {
      home: "Acasă",
      services: "Servicii",
      articles: "Articole",
      portfolio: "Portofoliu",
      about: "Despre",
      contact: "Contact",
      cta: "Începe acum",
      all_services: "Vezi toate serviciile",
      all_services_short: "Toate serviciile",
    },
    preloader: {
      loading: "Se încarcă...",
      welcome: "Bine ai venit",
      tagline: "Scrie-ți destinul.",
    },
    hero: {
      eyebrow: "Agenție Digitală Premium",
      title_line1: "Destinul tău",
      title_line2: "în social media.",
      subtitle:
        "Creăm campanii de ads și conținut social media care transformă brandurile în povești memorabile. Rezultate reale, nu promisiuni.",
      cta_primary: "Începe proiectul tău",
      cta_secondary: "Vezi serviciile",
      scroll: "Derulează",
    },
    marquee: ["Meta Ads", "Google Ads", "TikTok Ads", "LinkedIn Ads", "Social Media", "Content Strategy", "Branding"],
    stats: {
      subtitle: "Partenerul care livrează, nu doar rapoarte.",
      items: [
        {
          title: "Strategie la măsură",
          desc: "Plan personalizat pe obiectivele tale de business — nu pe template-uri copiate.",
        },
        {
          title: "Creative premium",
          desc: "Foto, video și copy care arată impecabil și opresc scroll-ul.",
        },
        {
          title: "Transparență totală",
          desc: "Știi mereu ce facem, de ce facem și ce urmează — comunicare clară, fără jargon.",
        },
        {
          title: "Focus pe rezultate",
          desc: "Optimizăm pentru conversii și ROI — nu pentru metrici de vanity.",
        },
      ],
    },
    homepageSettings: {
      showTestimonials: true,
      showWhyUs: true,
      showPortrait: true,
      showPartners: true,
      portraitScrollSeconds: 48,
      partnersScrollSeconds: 15,
    },
    serviceCards: [
      {
        slug: "social-media-management",
        label: "Content Creation + Social Media Management",
        desc: "Content premium, strategie și community.",
        cardLead:
          "Îți creștem vizibilitatea pe Instagram, TikTok, Facebook, Youtube și LinkedIn. De la strategie și creare de conținut, până la implementare și administrarea comunității, ne ocupăm de tot ce ai nevoie pentru a transforma audiența în clienți.",
      },
      {
        slug: "ads",
        label: "Paid ADS",
        desc: "Meta, Google, TikTok, LinkedIn, YouTube.",
        cardLead:
          "Campanii performance pe Meta, Google, TikTok, LinkedIn și YouTube. De la primul test până la scalare agresivă, cu obsesie pentru rezultate reale în afacerea ta.",
      },
      {
        slug: "website",
        label: "Website",
        desc: "eCommerce, WordPress, custom & SEO.",
      },
      {
        slug: "consultanta",
        label: "Consultanta Social Media",
        desc: "Strategie 1-la-1 pentru founderi și echipe.",
      },
    ],
    services: {
      eyebrow: "Ce facem",
      title: "Servicii create pentru creștere",
      subtitle: "",
      items: [
        {
          tag: "01",
          title: "Ads pe toate platformele",
          description:
            "Campanii Meta, Google, TikTok, LinkedIn, YouTube – strategie, creație, setup și optimizare zi de zi pentru ROI maxim.",
          bullets: ["Meta & Instagram Ads", "Google Ads & YouTube", "TikTok & LinkedIn", "Optimizare zilnică"],
        },
        {
          tag: "02",
          title: "Social Media Management",
          description:
            "Conținut care oprește scroll-ul. Gestionăm complet prezența ta online: strategie, foto, video, copy și community.",
          bullets: ["Strategie editorială", "Producție foto & video", "Copywriting", "Community management"],
        },
      ],
      cta: "Vezi toate serviciile",
    },
    process: {
      eyebrow: "PROCESUL NOSTRU",
      title: "Patru pași simpli către rezultate reale",
      steps: [
        { n: "01", title: "Audit", desc: "Audităm brandul, publicul și obiectivele." },
        { n: "02", title: "Strategie", desc: "Construim un plan cap-coadă pentru creștere." },
        { n: "03", title: "Execuție", desc: "Producem, lansăm și testăm creativele." },
        { n: "04", title: "Optimizare", desc: "Scalăm ce funcționează, oprim ce nu." },
      ],
    },
    testimonials: {
      eyebrow: "Ei vorbesc despre noi",
      title: "Povești spuse de clienți reali",
      items: [
        { quote: "Social Destiny ne-a dublat vânzările online în trei luni. Singura agenție care explică cifrele clar.", name: "Andreea Popescu", username: "@atelier_noir", role: "Fondator, Atelier Noir", country: "🇷🇴 România" },
        { quote: "Campaniile Meta și TikTok ne-au adus leaduri de 3x mai ieftine. Recomand cu încredere.", name: "Radu Ionescu", username: "@urbanfit", role: "CEO, Urban Fit", country: "🇷🇴 România" },
        { quote: "Echipa e obsedată de detalii. Creativele, copy-ul, raportările – totul la standard premium.", name: "Maria Dumitrescu", username: "@casaverde", role: "Marketing Lead, Casa Verde", country: "🇷🇴 România" },
        { quote: "În 6 săptămâni am ieșit pe profit din Meta Ads. Nimeni altcineva nu reușise până atunci.", name: "Cristian Voicu", username: "@brewlab", role: "Co-founder, BrewLab", country: "🇷🇴 România" },
        { quote: "Au preluat complet social media. Nu mai trebuie să mă gândesc la nimic, iar rezultatele se văd.", name: "Diana Ristea", username: "@studio_dr", role: "Owner, Studio DR", country: "🇲🇩 Moldova" },
        { quote: "TikTok-ul nostru a explodat. 0 la 80k followers în 4 luni, cu ROI real pe site.", name: "Paul Georgescu", username: "@kineticwear", role: "Founder, Kinetic Wear", country: "🇷🇴 România" },
        { quote: "Raportările săptămânale ne ajută să luăm decizii, nu să ne uităm la cifre goale.", name: "Ioana Stan", username: "@lumegold", role: "E-com Manager, Lume Gold", country: "🇷🇴 România" },
        { quote: "Am colaborat cu 4 agenții înainte. Social Destiny face cât toate la un loc.", name: "Alexandru Marin", username: "@northpeak", role: "CMO, North Peak", country: "🇷🇴 România" },
        { quote: "Creative video premium și strategie care scalează. Exact ce căutam.", name: "Bianca Tudor", username: "@bella_casa", role: "Fondator, Bella Casa", country: "🇮🇹 Italia" },
      ],
    },
    portraitShowcase: {
      eyebrow: "Din studio",
      title: "Momente care vorbesc",
      items: [],
    },
    partners: {
      eyebrow: "Parteneri",
      title: "Branduri cu care colaborăm",
      items: [],
    },
    cta_section: {
      eyebrow: "Hai să începem",
      title: "Următorul brand de succes poate fi al tău.",
      subtitle:
        "O conversație de 20 de minute poate schimba direcția afacerii tale. Nu costă nimic.",
      button: "Rezervă o discuție",
    },
    footer: {
      tagline: "Agenția care îți scrie destinul digital.",
      explore: "Explorează",
      services_title: "Servicii",
      services_list: ["Social Media Management", "Campanii ADS", "Website", "Consultanță"],
      service_links: [
        { slug: "social-media-management", label: "Social Media Management" },
        { slug: "ads", label: "Campanii ADS" },
        { slug: "website", label: "Website" },
        { slug: "consultanta", label: "Consultanță" },
      ],
      contact_title: "Contact",
      policies_title: "Politici",
      privacy_link: "Politica de Confidențialitate",
      terms_link: "Termeni și Condiții",
      cookies_link: "Politica de Cookie-uri",
      rights: "Toate drepturile rezervate.",
      made_with: "Creat cu grijă în București.",
    },
    cookieConsent: {
      banner_title: "Respectăm confidențialitatea ta",
      banner_text:
        "Folosim cookie-uri pentru a asigura funcționarea site-ului, pentru preferințe și, cu acordul tău, pentru conținut media de la terți. Poți accepta, refuza sau personaliza.",
      policy_link: "Politica de Cookie-uri",
      accept_all: "Accept toate",
      reject_all: "Refuză neesențiale",
      customize: "Personalizează",
      modal_title: "Preferințe cookie",
      modal_intro:
        "Alege ce categorii de cookie-uri permiți. Cookie-urile necesare nu pot fi dezactivate deoarece site-ul nu ar funcționa corect fără ele.",
      save_preferences: "Salvează preferințele",
      close: "Închide",
      settings_short: "Cookie-uri",
      always_on: "Întotdeauna activ",
      col_name: "Nume",
      col_provider: "Furnizor",
      col_purpose: "Scop",
      col_duration: "Durată maximă",
      col_type: "Tip",
      no_cookies: "Niciun cookie în această categorie momentan.",
      domain_label: "Domeniul consimțământului",
      state_label: "Starea curentă",
      consent_id_label: "ID consimțământ",
      consent_date_label: "Data consimțământului",
      not_set: "Nesetat",
      change_consent: "Modifică consimțământul",
      withdraw_consent: "Retrage consimțământul",
      states: {
        allow_all: "Accept toate",
        deny_all: "Doar necesare",
        custom: "Personalizat",
      },
    },
    cookieDeclaration: {
      title: "Declarație cookie-uri",
      intro:
        "Acest site folosește cookie-uri. Le folosim pentru funcționare, preferințe de limbă și, cu permisiunea ta, pentru conținut media încorporat (ex. YouTube). Poți modifica sau retrage consimțământul oricând.",
      consent_note:
        "Te rugăm să menționezi ID-ul și data consimțământului dacă ne contactezi în legătură cu preferințele tale cookie. Află mai multe în Politica de Confidențialitate.",
      last_updated_label: "Declarația cookie a fost actualizată la",
      last_updated: "iunie 2025",
      categories: [
        {
          id: "necessary",
          name: "Necesare",
          description:
            "Cookie-urile necesare ajută la utilizarea site-ului (navigare, securitate, salvarea consimțământului și preferința de limbă). Site-ul nu poate funcționa corect fără ele.",
        },
        {
          id: "preferences",
          name: "Preferințe",
          description: "Permit site-ului să rețină alegeri care îți îmbunătățesc experiența (ex. setări opționale).",
        },
        {
          id: "statistics",
          name: "Statistici",
          description: "Ne ajută să înțelegem cum este folosit site-ul, în mod anonim, pentru îmbunătățiri.",
        },
        {
          id: "marketing",
          name: "Marketing / Terți",
          description:
            "Folosite pentru conținut media încorporat de la terți (ex. YouTube) și, în viitor, pentru campanii sau remarketing.",
        },
      ],
      cookies: [
        {
          category: "necessary",
          name: "sd_cookie_consent",
          provider: "socialdestiny.ro",
          purpose: "Stochează starea consimțământului cookie (ID, dată, categorii)",
          duration: "1 an",
          type: "HTTP Cookie",
        },
        {
          category: "necessary",
          name: "sd_lang",
          provider: "socialdestiny.ro",
          purpose: "Salvează limba selectată (RO/EN)",
          duration: "Persistent",
          type: "Local Storage",
        },
        {
          category: "marketing",
          name: "VISITOR_INFO1_LIVE / YSC",
          provider: "youtube.com",
          purpose: "Cookie-uri setate la redarea videoclipurilor YouTube încorporate",
          duration: "Variabilă",
          type: "Cookie terț",
        },
      ],
    },
    legal: {
      privacy: {
        title: "Politica de Confidențialitate",
        updated: "Ultima actualizare: iunie 2025",
        sections: [
          {
            heading: "1. Cine suntem",
            body:
              "Social Destiny prelucrează datele cu caracter personal în calitate de operator, în conformitate cu Regulamentul (UE) 2016/679 (GDPR) și legislația națională aplicabilă. Datele de contact ale operatorului sunt afișate în footer-ul site-ului.",
          },
          {
            heading: "2. Ce date colectăm",
            body:
              "Putem prelucra: nume, adresă de e-mail, număr de telefon, mesajul transmis prin formularul de contact, date tehnice de navigare (adresă IP, tip browser, pagini vizitate) și preferința de limbă. Nu vindem datele tale către terți.",
          },
          {
            heading: "3. Scopul prelucrării",
            body:
              "Datele sunt folosite pentru a răspunde solicitărilor, a oferi serviciile noastre, a îmbunătăți site-ul, a respecta obligații legale și, cu consimțământul tău, pentru comunicări de marketing.",
          },
          {
            heading: "4. Temeiul legal",
            body:
              "Ne bazăm pe executarea unui contract sau demersuri precontractuale, interes legitim (securitate, analiză), obligație legală sau consimțământ, după caz.",
          },
          {
            heading: "5. Drepturile tale",
            body:
              "Ai dreptul de acces, rectificare, ștergere, restricționare, portabilitate, opoziție și de a depune plângere la ANSPDCP. Pentru exercitarea drepturilor, scrie-ne la adresa de e-mail din footer.",
          },
          {
            heading: "6. Păstrarea datelor",
            body:
              "Păstrăm datele doar cât este necesar scopurilor menționate sau cât impune legea. Mesajele din formularul de contact sunt păstrate pe durata colaborării și conform politicilor interne.",
          },
        ],
      },
      terms: {
        title: "Termeni și Condiții",
        updated: "Ultima actualizare: iunie 2025",
        sections: [
          {
            heading: "1. Acceptarea termenilor",
            body:
              "Accesând și utilizând site-ul socialdestiny.ro, accepți acești termeni. Dacă nu ești de acord, te rugăm să nu utilizezi site-ul.",
          },
          {
            heading: "2. Serviciile noastre",
            body:
              "Informațiile de pe site au caracter informativ. Ofertele comerciale, prețurile și condițiile finale se stabilesc prin contract sau ofertă scrisă, semnată de ambele părți.",
          },
          {
            heading: "3. Proprietate intelectuală",
            body:
              "Conținutul site-ului (texte, imagini, logo, design) aparține Social Destiny sau licențiatorilor și nu poate fi copiat, distribuit sau folosit fără acordul nostru scris.",
          },
          {
            heading: "4. Limitarea răspunderii",
            body:
              "Depunem eforturi pentru acuratețea informațiilor, însă nu garantăm că site-ul va fi mereu disponibil sau lipsit de erori. Nu răspundem pentru daune indirecte rezultate din utilizarea site-ului.",
          },
          {
            heading: "5. Link-uri către terți",
            body:
              "Site-ul poate conține link-uri către platforme externe. Nu suntem responsabili pentru conținutul sau politicile acelor site-uri.",
          },
          {
            heading: "6. Legea aplicabilă",
            body:
              "Acești termeni sunt guvernați de legea română. Orice litigiu va fi soluționat de instanțele competente din România.",
          },
        ],
      },
      cookies: {
        title: "Politica de Cookie-uri",
        updated: "Ultima actualizare: iunie 2025",
        sections: [
          {
            heading: "1. Ce sunt cookie-urile",
            body:
              "Cookie-urile sunt fișiere mici stocate pe dispozitivul tău când vizitezi un site. Ne ajută să oferim o experiență funcțională și să înțelegem cum este utilizat site-ul.",
          },
          {
            heading: "2. Ce cookie-uri folosim",
            body:
              "• Cookie-uri strict necesare — funcționarea site-ului și preferința de limbă (localStorage).\n• Cookie-uri de performanță — date anonime despre trafic, dacă sunt activate.\n• Cookie-uri de la terți — pot apărea la embed-uri (ex. YouTube) conform politicilor acelor platforme.",
          },
          {
            heading: "3. Cum poți controla cookie-urile",
            body:
              "Poți șterge sau bloca cookie-urile din setările browserului. Dezactivarea anumitor cookie-uri poate afecta funcționalitatea site-ului.",
          },
          {
            heading: "4. Actualizări",
            body:
              "Putem actualiza această politică periodic. Te încurajăm să revii pe această pagină pentru informații la zi.",
          },
        ],
      },
    },
    about: {
      eyebrow: "Despre Social Destiny",
      title: "Construim branduri memorabile prin social media și ads.",
      lead:
        "Social Destiny s-a născut din convingerea că fiecare brand are o poveste. Noi o traducem în campanii care cresc și în conținut care vinde.",
      p1:
        "Lucrăm cu antreprenori, fondatori și echipe de marketing care vor mai mult decât likes. Vor creștere. Vor conversii. Vor brand.",
      p2:
        "Combinăm strategia de performance marketing cu creativitatea conținutului premium. Pentru că reclamele funcționează cel mai bine când comunică o identitate clară.",
      values_title: "Valorile noastre",
      values: [
        { title: "Transparență", desc: "Rapoarte clare, cifre reale, zero jargoane." },
        { title: "Creativitate", desc: "Fiecare post, fiecare ad — construit să iasă în evidență." },
        { title: "Rezultate", desc: "Nu ne plătești pentru muncă. Ne plătești pentru rezultate." },
        { title: "Parteneriat", desc: "Suntem o extensie a echipei tale, nu un furnizor extern." },
      ],
      team_title: "Fondator",
      team_name: "Alex Marinescu",
      team_role: "Founder & Head of Strategy",
      team_bio:
        "7+ ani de experiență în performance marketing și branding. A condus campanii pentru peste 120 de branduri, de la startup-uri la companii enterprise.",
      team_image:
        "https://images.pexels.com/photos/17582358/pexels-photo-17582358.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      section_image:
        "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1200&q=80",
      section_image_title: "Brandul tău nu are nevoie de mai mult conținut. Are nevoie de o direcție.",
      section_image_body:
        "Ce facem noi diferit e simplu: înainte să apăsăm vreun buton pe Ads Manager sau să publicăm vreun reel, stăm jos și înțelegem. Ce vrea clientul tău, ce te diferențiază de competiție, unde se ascund oportunitățile reale. Abia apoi construim.",
      section_image_points: [
        "Strategie înainte de execuție",
        "Echipă mică, focus maxim",
        "Transparență totală pe cifre",
        "Parteneriat pe termen lung",
      ],
      team_showcase: {
        eyebrow: "Echipa",
        title: "Oamenii care construiesc brandul tău",
      },
      team_members: [
        {
          image:
            "https://images.pexels.com/photos/17582358/pexels-photo-17582358.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
          label: "Fondator",
          name: "Alex Marinescu",
          role: "Founder & Head of Strategy",
          bio: "Performance marketing și branding — 120+ branduri, de la startup la enterprise.",
        },
        {
          image:
            "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=800&q=80",
          label: "Social & Content",
          name: "Maria Ionescu",
          role: "Head of Social Media",
          bio: "Strategie editorială, Reels și community care transformă audiența în clienți.",
        },
        {
          image:
            "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=800&q=80",
          label: "Ads & Performance",
          name: "Andrei Popescu",
          role: "Performance Lead",
          bio: "Campanii Meta, Google și TikTok — testare, scalare și raportare clară.",
        },
        {
          image:
            "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=800&q=80",
          label: "Creative",
          name: "Elena Dumitru",
          role: "Creative Director",
          bio: "Direcție vizuală, shoot-uri și identitate coerentă pe toate canalele.",
        },
      ],
    },
    services_page: {
      eyebrow: "Serviciile noastre",
      title: "Ce poate face Social Destiny pentru tine.",
      subtitle:
        "Alege o direcție sau combină-le. În ambele cazuri, livrăm strategia, creația și rezultatele.",
      trust_points: ["Strategie înainte de execuție", "Echipă dedicată, fără outsourcing", "Raportare transparentă"],
      expertise_kicker: "01 · Expertiză",
      expertise_title: "Patru piloni. Un singur motor de creștere.",
      detailed: [
        {
          num: "01",
          title: "Ads pe toate platformele",
          intro:
            "Campanii performance pe Meta, Google, TikTok, LinkedIn și YouTube. De la primul test până la scalare agresivă.",
          features: [
            "Audit complet al contului și strategiei actuale",
            "Structură cont optimizată pentru scalare",
            "Creative testing săptămânal (video, static, UGC)",
            "Landing page feedback și CRO tips",
            "Raportare săptămânală cu insights acționabile",
            "Consultanță directă cu strategul",
          ],
          featuresText: "",
        },
        {
          num: "02",
          title: "Social Media Management",
          intro:
            "Prezență completă pe Instagram, TikTok, Facebook și LinkedIn. Conținut premium, publicare, community și strategie lunară.",
          features: [
            "Strategie editorială lunară pe canal",
            "Producție foto & video de la A la Z",
            "Copywriting optimizat pentru engagement",
            "Publicare și community management zilnic",
            "Reels & TikToks focusate pe reach organic",
            "Analiză lunară de performanță",
          ],
          featuresText: "",
        },
      ],
      cta_title: "Nu ești sigur ce se potrivește brandului tău?",
      cta_subtitle: "Hai să vorbim 20 de minute. Îți spunem direct ce merită făcut.",
      cta_button: "Programează o discuție",
    },
    contact: {
      eyebrow: "Hai să vorbim",
      title: "Începe povestea cu Social Destiny.",
      subtitle:
        "Completează formularul și îți răspundem în maxim 24 de ore. Fără pitch-uri lungi, doar răspunsuri directe.",
      form: {
        name: "Numele tău",
        email: "Email",
        phone: "Telefon (opțional)",
        service: "Ce te interesează?",
        service_options: [
          "Social Media Management",
          "Campanii ADS",
          "Website",
          "Consultanță Marketing",
          "Altceva",
        ],
        service_other: "Altceva",
        budget: "Buget lunar estimat",
        budget_options: ["<500€", "500 – 1.500€", "1.500 – 5.000€", "5.000€+", "Nu știu încă"],
        message: "Spune-ne despre proiect",
        submit: "Trimite mesajul",
        submitting: "Se trimite...",
        success: "Mulțumim! Te contactăm în curând.",
        error: "A apărut o eroare. Te rugăm încearcă din nou.",
        rate_limited:
          "Prea multe încercări din aceeași rețea. Așteaptă câteva minute și încearcă din nou.",
      },
      info_title: "Alte căi de contact",
      email_label: "Email",
      phone_label: "Telefon",
      location_label: "Birou",
      location_value: "București, România",
      hours_label: "Program",
      hours_value: "Luni – Vineri, 09:00 – 18:00",
    },
    portfolio: {
      eyebrow: "Portofoliu",
      title: "Branduri care au crescut cu noi.",
      subtitle: "Selecție de proiecte la care am lucrat recent. De la ecommerce la servicii și branduri de lifestyle.",
      showcase_eyebrow: "În spatele proiectelor",
      showcase_title: "Curios ce am construit până acum?",
      showcase_subtitle:
        "Identități vizuale, campanii și prezențe digitale — o selecție din proiectele care ne definesc stilul.",
      showcase_cta: "Programează o discuție",
      pillars: [
        { n: "01", title: "Strategie & planificare" },
        { n: "02", title: "Design & producție" },
        { n: "03", title: "Lansare & creștere" },
        { n: "04", title: "Optimizare continuă" },
      ],
      cta: "Hai să construim și povestea ta",
      cta_subtitle: "O conversație de 20 de minute poate schimba direcția. Nu costă nimic.",
      items: [
        { name: "Atelier Noir", service: "Social Media + Meta Ads", image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=1200&q=80" },
        { name: "Urban Fit", service: "TikTok Ads + Web", image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=1200&q=80" },
        { name: "Casa Verde", service: "Social Media Management", image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=80" },
        { name: "BrewLab", service: "Performance Marketing", image: "https://images.unsplash.com/photo-1511920170033-f8396924c348?auto=format&fit=crop&w=1200&q=80" },
        { name: "Kinetic Wear", service: "Branding + Ecommerce", image: "https://images.unsplash.com/photo-1556906781-9a412961c28c?auto=format&fit=crop&w=1200&q=80" },
        { name: "Lume Gold", service: "Google Ads + SEO", image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=1200&q=80" },
        { name: "North Peak", service: "Consultanță + Strategie", image: "https://images.unsplash.com/photo-1519748771451-a94c596fad67?auto=format&fit=crop&w=1200&q=80" },
        { name: "Studio DR", service: "Website + Social Media", image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80" },
        { name: "Bella Casa", service: "Meta Ads + Content", image: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1200&q=80" },
      ],
    },
    articles_page: {
      eyebrow: "Insights",
      title: "Articole & perspective",
      subtitle: "Idei practice despre ads, social media și creștere — răspunsuri clare, fără fluff.",
      empty: "Pregătim primele articole. Revino curând.",
      read_more: "Citește articolul",
      back: "Toate articolele",
    },
    articles: articlesRo,
    pagesSeo: {
      home: { title: "", description: "" },
      services: { title: "", description: "" },
      portfolio: { title: "", description: "" },
      about: { title: "", description: "" },
      contact: { title: "", description: "" },
      articles: { title: "", description: "" },
    },
    trusted: "+120 de clienți au scris un capitol cu noi",
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      articles: "Articles",
      portfolio: "Portfolio",
      about: "About",
      contact: "Contact",
      cta: "Get started",
      all_services: "View all services",
      all_services_short: "All services",
    },
    preloader: {
      loading: "Loading...",
      welcome: "Welcome",
      tagline: "Write your destiny.",
    },
    hero: {
      eyebrow: "Premium Digital Agency",
      title_line1: "Your destiny",
      title_line2: "in social media.",
      subtitle:
        "We craft ad campaigns and social media content that turn brands into memorable stories. Real results, not promises.",
      cta_primary: "Start your project",
      cta_secondary: "See our services",
      scroll: "Scroll",
    },
    marquee: ["Meta Ads", "Google Ads", "TikTok Ads", "LinkedIn Ads", "Social Media", "Content Strategy", "Branding"],
    stats: {
      subtitle: "A partner that delivers — not just reports.",
      items: [
        {
          title: "Tailored strategy",
          desc: "A plan built around your business goals — not copied templates.",
        },
        {
          title: "Premium creative",
          desc: "Photo, video and copy that look impeccable and stop the scroll.",
        },
        {
          title: "Full transparency",
          desc: "You always know what we do, why we do it and what's next — clear communication, no jargon.",
        },
        {
          title: "Results-focused",
          desc: "We optimize for conversions and ROI — not vanity metrics.",
        },
      ],
    },
    homepageSettings: {
      showTestimonials: true,
      showWhyUs: true,
      showPortrait: true,
      showPartners: true,
      portraitScrollSeconds: 48,
      partnersScrollSeconds: 15,
    },
    serviceCards: [
      {
        slug: "social-media-management",
        label: "Content Creation + Social Media Management",
        desc: "Premium content, strategy and community.",
        cardLead:
          "We grow your visibility on Instagram, TikTok, Facebook, YouTube and LinkedIn — from strategy and content creation to implementation and community management.",
      },
      {
        slug: "ads",
        label: "Paid ADS",
        desc: "Meta, Google, TikTok, LinkedIn, YouTube.",
        cardLead:
          "Performance campaigns on Meta, Google, TikTok, LinkedIn and YouTube — from the first test to aggressive scaling, obsessed with real results for your business.",
      },
      { slug: "website", label: "Website", desc: "eCommerce, WordPress, custom & SEO." },
      { slug: "consultanta", label: "Social Media Consulting", desc: "1-on-1 strategy for founders and teams." },
    ],
    services: {
      eyebrow: "What we do",
      title: "Services built for growth",
      subtitle: "",
      items: [
        {
          tag: "01",
          title: "Ads on every platform",
          description:
            "Meta, Google, TikTok, LinkedIn and YouTube campaigns — strategy, creative, setup and daily optimisation for maximum ROI.",
          bullets: ["Meta & Instagram Ads", "Google Ads & YouTube", "TikTok & LinkedIn", "Daily optimisation"],
        },
        {
          tag: "02",
          title: "Social Media Management",
          description:
            "Content that stops the scroll. We manage your online presence from strategy to photo, video, copy and community.",
          bullets: ["Editorial strategy", "Photo & video production", "Copywriting", "Community management"],
        },
      ],
      cta: "View all services",
    },
    process: {
      eyebrow: "OUR PROCESS",
      title: "Four simple steps to real results",
      steps: [
        { n: "01", title: "Audit", desc: "We audit your brand, audience and goals." },
        { n: "02", title: "Strategy", desc: "We build an end-to-end plan for growth." },
        { n: "03", title: "Execution", desc: "We produce, launch and test creatives." },
        { n: "04", title: "Optimisation", desc: "We scale what works, stop what doesn't." },
      ],
    },
    testimonials: {
      eyebrow: "They talk about us",
      title: "Stories told by real clients",
      items: [
        { quote: "Social Destiny doubled our online sales in three months. The only agency that explains the numbers clearly.", name: "Andreea Popescu", username: "@atelier_noir", role: "Founder, Atelier Noir", country: "🇷🇴 Romania" },
        { quote: "The Meta and TikTok campaigns brought us leads 3x cheaper. I fully recommend them.", name: "Radu Ionescu", username: "@urbanfit", role: "CEO, Urban Fit", country: "🇷🇴 Romania" },
        { quote: "The team is obsessed with details. Creatives, copy, reporting — all premium.", name: "Maria Dumitrescu", username: "@casaverde", role: "Marketing Lead, Casa Verde", country: "🇷🇴 Romania" },
        { quote: "In 6 weeks we turned profitable on Meta Ads. No one else managed that before.", name: "Cristian Voicu", username: "@brewlab", role: "Co-founder, BrewLab", country: "🇷🇴 Romania" },
        { quote: "They fully took over social media. I don't have to think about it — and the results show.", name: "Diana Ristea", username: "@studio_dr", role: "Owner, Studio DR", country: "🇲🇩 Moldova" },
        { quote: "Our TikTok exploded. 0 to 80k followers in 4 months with real ROI on the site.", name: "Paul Georgescu", username: "@kineticwear", role: "Founder, Kinetic Wear", country: "🇷🇴 Romania" },
        { quote: "Weekly reports help us make decisions, not just stare at empty numbers.", name: "Ioana Stan", username: "@lumegold", role: "E-com Manager, Lume Gold", country: "🇷🇴 Romania" },
        { quote: "We worked with 4 agencies before. Social Destiny does as much as all of them combined.", name: "Alexandru Marin", username: "@northpeak", role: "CMO, North Peak", country: "🇷🇴 Romania" },
        { quote: "Premium video creatives and a strategy that scales. Exactly what we needed.", name: "Bianca Tudor", username: "@bella_casa", role: "Founder, Bella Casa", country: "🇮🇹 Italy" },
      ],
    },
    portraitShowcase: {
      eyebrow: "From the studio",
      title: "Moments that speak",
      items: [],
    },
    partners: {
      eyebrow: "Partners",
      title: "Brands we've worked with",
      items: [],
    },
    cta_section: {
      eyebrow: "Let's get started",
      title: "The next success story could be yours.",
      subtitle:
        "A 20-minute conversation could change your business direction. No cost attached.",
      button: "Book a call",
    },
    footer: {
      tagline: "The agency writing your digital destiny.",
      explore: "Explore",
      services_title: "Services",
      services_list: ["Social Media Management", "ADS Campaigns", "Websites", "Consulting"],
      service_links: [
        { slug: "social-media-management", label: "Social Media Management" },
        { slug: "ads", label: "ADS Campaigns" },
        { slug: "website", label: "Websites" },
        { slug: "consultanta", label: "Consulting" },
      ],
      contact_title: "Contact",
      policies_title: "Policies",
      privacy_link: "Privacy Policy",
      terms_link: "Terms & Conditions",
      cookies_link: "Cookie Policy",
      rights: "All rights reserved.",
      made_with: "Crafted with care in Bucharest.",
    },
    cookieConsent: {
      banner_title: "We respect your privacy",
      banner_text:
        "We use cookies to run the site, remember preferences and, with your consent, load third-party media. You can accept, reject or customise.",
      policy_link: "Cookie Policy",
      accept_all: "Accept all",
      reject_all: "Reject non-essential",
      customize: "Customise",
      modal_title: "Cookie preferences",
      modal_intro:
        "Choose which cookie categories to allow. Necessary cookies cannot be disabled because the site would not work properly without them.",
      save_preferences: "Save preferences",
      close: "Close",
      settings_short: "Cookies",
      always_on: "Always on",
      col_name: "Name",
      col_provider: "Provider",
      col_purpose: "Purpose",
      col_duration: "Max. duration",
      col_type: "Type",
      no_cookies: "No cookies in this category at the moment.",
      domain_label: "Consent applies to",
      state_label: "Your current state",
      consent_id_label: "Consent ID",
      consent_date_label: "Consent date",
      not_set: "Not set",
      change_consent: "Change your consent",
      withdraw_consent: "Withdraw your consent",
      states: {
        allow_all: "Allow all",
        deny_all: "Necessary only",
        custom: "Custom",
      },
    },
    cookieDeclaration: {
      title: "Cookie declaration",
      intro:
        "This website uses cookies for operation, language preferences and, with your permission, embedded third-party media (e.g. YouTube). You can change or withdraw consent at any time.",
      consent_note:
        "Please state your consent ID and date when you contact us about your cookie preferences. Learn more in our Privacy Policy.",
      last_updated_label: "Cookie declaration last updated on",
      last_updated: "June 2025",
      categories: [
        {
          id: "necessary",
          name: "Necessary",
          description:
            "Necessary cookies help make the website usable (navigation, security, consent storage and language preference). The site cannot function properly without them.",
        },
        {
          id: "preferences",
          name: "Preferences",
          description: "Allow the site to remember choices that improve your experience.",
        },
        {
          id: "statistics",
          name: "Statistics",
          description: "Help us understand how the site is used, anonymously, for improvements.",
        },
        {
          id: "marketing",
          name: "Marketing / Third-party",
          description: "Used for embedded third-party media (e.g. YouTube) and future marketing tools.",
        },
      ],
      cookies: [
        {
          category: "necessary",
          name: "sd_cookie_consent",
          provider: "socialdestiny.ro",
          purpose: "Stores cookie consent state (ID, date, categories)",
          duration: "1 year",
          type: "HTTP Cookie",
        },
        {
          category: "necessary",
          name: "sd_lang",
          provider: "socialdestiny.ro",
          purpose: "Stores selected language (RO/EN)",
          duration: "Persistent",
          type: "Local Storage",
        },
        {
          category: "marketing",
          name: "VISITOR_INFO1_LIVE / YSC",
          provider: "youtube.com",
          purpose: "Set when embedded YouTube videos are played",
          duration: "Variable",
          type: "Third-party cookie",
        },
      ],
    },
    legal: {
      privacy: {
        title: "Privacy Policy",
        updated: "Last updated: June 2025",
        sections: [
          {
            heading: "1. Who we are",
            body:
              "Social Destiny processes personal data as a data controller in accordance with GDPR and applicable national law. Operator contact details are shown in the site footer.",
          },
          {
            heading: "2. Data we collect",
            body:
              "We may process: name, email, phone number, contact form message, technical browsing data (IP, browser type, pages visited) and language preference. We do not sell your data to third parties.",
          },
          {
            heading: "3. Purpose of processing",
            body:
              "Data is used to respond to enquiries, deliver our services, improve the website, meet legal obligations and, with your consent, for marketing communications.",
          },
          {
            heading: "4. Legal basis",
            body:
              "We rely on contract performance, legitimate interest (security, analytics), legal obligation or consent, as applicable.",
          },
          {
            heading: "5. Your rights",
            body:
              "You have the right of access, rectification, erasure, restriction, portability, objection and to lodge a complaint with your supervisory authority. Contact us using the email in the footer.",
          },
          {
            heading: "6. Retention",
            body:
              "We keep data only as long as necessary for the stated purposes or as required by law.",
          },
        ],
      },
      terms: {
        title: "Terms & Conditions",
        updated: "Last updated: June 2025",
        sections: [
          {
            heading: "1. Acceptance",
            body:
              "By accessing socialdestiny.ro you accept these terms. If you do not agree, please do not use the site.",
          },
          {
            heading: "2. Our services",
            body:
              "Site information is indicative. Commercial offers, pricing and final terms are set out in a written contract or signed proposal.",
          },
          {
            heading: "3. Intellectual property",
            body:
              "Site content (text, images, logo, design) belongs to Social Destiny or licensors and may not be copied or used without written permission.",
          },
          {
            heading: "4. Limitation of liability",
            body:
              "We strive for accuracy but do not guarantee uninterrupted or error-free access. We are not liable for indirect damages arising from use of the site.",
          },
          {
            heading: "5. Third-party links",
            body:
              "The site may link to external platforms. We are not responsible for their content or policies.",
          },
          {
            heading: "6. Governing law",
            body:
              "These terms are governed by Romanian law. Disputes shall be resolved by the competent courts in Romania.",
          },
        ],
      },
      cookies: {
        title: "Cookie Policy",
        updated: "Last updated: June 2025",
        sections: [
          {
            heading: "1. What are cookies",
            body:
              "Cookies are small files stored on your device when you visit a site. They help us provide a functional experience and understand how the site is used.",
          },
          {
            heading: "2. Cookies we use",
            body:
              "• Strictly necessary — site operation and language preference (localStorage).\n• Performance — anonymous traffic data, if enabled.\n• Third-party — may appear on embeds (e.g. YouTube) per those platforms' policies.",
          },
          {
            heading: "3. How to control cookies",
            body:
              "You can delete or block cookies in your browser settings. Disabling certain cookies may affect site functionality.",
          },
          {
            heading: "4. Updates",
            body:
              "We may update this policy periodically. Please check this page for the latest information.",
          },
        ],
      },
    },
    about: {
      eyebrow: "About Social Destiny",
      title: "We build memorable brands through social media and ads.",
      lead:
        "Social Destiny was born from the belief that every brand has a story. We translate it into campaigns that grow and content that sells.",
      p1:
        "We work with entrepreneurs, founders and marketing teams who want more than likes. They want growth. They want conversions. They want a brand.",
      p2:
        "We combine performance marketing strategy with premium content creativity. Because ads work best when they communicate a clear identity.",
      values_title: "Our values",
      values: [
        { title: "Transparency", desc: "Clear reports, real numbers, zero jargon." },
        { title: "Creativity", desc: "Every post, every ad — built to stand out." },
        { title: "Results", desc: "You're not paying for work. You're paying for results." },
        { title: "Partnership", desc: "We're an extension of your team, not an external vendor." },
      ],
      team_title: "Founder",
      team_name: "Alex Marinescu",
      team_role: "Founder & Head of Strategy",
      team_bio:
        "7+ years of experience in performance marketing and branding. Led campaigns for 120+ brands, from startups to enterprise companies.",
      team_image:
        "https://images.pexels.com/photos/17582358/pexels-photo-17582358.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      section_image:
        "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1200&q=80",
      section_image_title: "Your brand doesn't need more content. It needs direction.",
      section_image_body:
        "What we do differently is simple: before we press any button in Ads Manager or publish any reel, we sit down and understand. What your client wants, what sets you apart, where the real opportunities hide. Only then do we build.",
      section_image_points: [
        "Strategy before execution",
        "Small team, maximum focus",
        "Total transparency on numbers",
        "Long-term partnership",
      ],
      team_showcase: {
        eyebrow: "The team",
        title: "The people behind your brand",
      },
      team_members: [
        {
          image:
            "https://images.pexels.com/photos/17582358/pexels-photo-17582358.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
          label: "Founder",
          name: "Alex Marinescu",
          role: "Founder & Head of Strategy",
          bio: "Performance marketing and branding — 120+ brands, from startup to enterprise.",
        },
        {
          image:
            "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=800&q=80",
          label: "Social & Content",
          name: "Maria Ionescu",
          role: "Head of Social Media",
          bio: "Editorial strategy, Reels and community that turn audience into customers.",
        },
        {
          image:
            "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=800&q=80",
          label: "Ads & Performance",
          name: "Andrei Popescu",
          role: "Performance Lead",
          bio: "Meta, Google and TikTok campaigns — testing, scaling and clear reporting.",
        },
        {
          image:
            "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=800&q=80",
          label: "Creative",
          name: "Elena Dumitru",
          role: "Creative Director",
          bio: "Visual direction, shoots and cohesive identity across every channel.",
        },
      ],
    },
    services_page: {
      eyebrow: "Our services",
      title: "What Social Destiny can do for you.",
      subtitle:
        "Pick a direction or combine them. Either way, we deliver the strategy, the creative and the results.",
      trust_points: ["Strategy before execution", "Dedicated team, no outsourcing", "Transparent reporting"],
      expertise_kicker: "01 · Expertise",
      expertise_title: "Four pillars. One growth engine.",
      detailed: [
        {
          num: "01",
          title: "Ads on every platform",
          intro:
            "Performance campaigns on Meta, Google, TikTok, LinkedIn and YouTube. From the first test to aggressive scaling.",
          features: [
            "Complete audit of current account and strategy",
            "Account structure optimised for scaling",
            "Weekly creative testing (video, static, UGC)",
            "Landing page feedback and CRO tips",
            "Weekly reporting with actionable insights",
            "Direct consulting with the strategist",
          ],
          featuresText: "",
        },
        {
          num: "02",
          title: "Social Media Management",
          intro:
            "Full presence on Instagram, TikTok, Facebook and LinkedIn. Premium content, publishing, community and monthly strategy.",
          features: [
            "Monthly editorial strategy per channel",
            "Photo & video production from A to Z",
            "Engagement-optimised copywriting",
            "Daily publishing and community management",
            "Reels & TikToks focused on organic reach",
            "Monthly performance analysis",
          ],
          featuresText: "",
        },
      ],
      cta_title: "Not sure what fits your brand?",
      cta_subtitle: "Let's talk for 20 minutes. We'll tell you directly what's worth doing.",
      cta_button: "Schedule a call",
    },
    contact: {
      eyebrow: "Let's talk",
      title: "Start the story with Social Destiny.",
      subtitle:
        "Fill in the form and we'll reply within 24 hours max. No long pitches, just direct answers.",
      form: {
        name: "Your name",
        email: "Email",
        phone: "Phone (optional)",
        service: "What are you interested in?",
        service_options: [
          "Social Media Management",
          "ADS Campaigns",
          "Websites",
          "Marketing Consulting",
          "Something else",
        ],
        service_other: "Something else",
        budget: "Estimated monthly budget",
        budget_options: ["<€500", "€500 – €1,500", "€1,500 – €5,000", "€5,000+", "Not sure yet"],
        message: "Tell us about the project",
        submit: "Send message",
        submitting: "Sending...",
        success: "Thanks! We'll be in touch soon.",
        error: "Something went wrong. Please try again.",
        rate_limited:
          "Too many attempts from this network. Please wait a few minutes and try again.",
      },
      info_title: "Other ways to reach us",
      email_label: "Email",
      phone_label: "Phone",
      location_label: "Office",
      location_value: "Bucharest, Romania",
      hours_label: "Hours",
      hours_value: "Monday – Friday, 09:00 – 18:00",
    },
    portfolio: {
      eyebrow: "Portfolio",
      title: "Brands that grew with us.",
      subtitle: "A selection of recent projects. From ecommerce to services and lifestyle brands.",
      showcase_eyebrow: "Behind the work",
      showcase_title: "Curious what we've built so far?",
      showcase_subtitle:
        "Visual identities, campaigns and digital presence — a selection of projects that define our craft.",
      showcase_cta: "Book a call",
      pillars: [
        { n: "01", title: "Strategy & planning" },
        { n: "02", title: "Design & production" },
        { n: "03", title: "Launch & growth" },
        { n: "04", title: "Continuous optimization" },
      ],
      cta: "Let's build your story too",
      cta_subtitle: "A 20-minute conversation could change your direction. No cost attached.",
      items: [
        { name: "Atelier Noir", service: "Social Media + Meta Ads", image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=1200&q=80" },
        { name: "Urban Fit", service: "TikTok Ads + Web", image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=1200&q=80" },
        { name: "Casa Verde", service: "Social Media Management", image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=80" },
        { name: "BrewLab", service: "Performance Marketing", image: "https://images.unsplash.com/photo-1511920170033-f8396924c348?auto=format&fit=crop&w=1200&q=80" },
        { name: "Kinetic Wear", service: "Branding + Ecommerce", image: "https://images.unsplash.com/photo-1556906781-9a412961c28c?auto=format&fit=crop&w=1200&q=80" },
        { name: "Lume Gold", service: "Google Ads + SEO", image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=1200&q=80" },
        { name: "North Peak", service: "Consulting + Strategy", image: "https://images.unsplash.com/photo-1519748771451-a94c596fad67?auto=format&fit=crop&w=1200&q=80" },
        { name: "Studio DR", service: "Website + Social Media", image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80" },
        { name: "Bella Casa", service: "Meta Ads + Content", image: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1200&q=80" },
      ],
    },
    articles_page: {
      eyebrow: "Insights",
      title: "Articles & perspectives",
      subtitle: "Practical ideas on ads, social media and growth — clear answers, no fluff.",
      empty: "First articles are on the way. Check back soon.",
      read_more: "Read article",
      back: "All articles",
    },
    articles: articlesEn,
    trusted: "+120 clients wrote a chapter with us",
  },
};

export const contactInfo = {
  email: "contact@socialdestiny.ro",
  phone: "+40 735 198 553",
  instagram: "@socialdestiny.ro",
  companyName: "Social Destiny S.R.L.",
  companyCui: "55068410",
  /** Public URL: static `/logo_sd.png` or `/api/uploads/...` after upload in admin */
  logoUrl: "/logo_sd.png",
  /** Opțional: logo diferit în footer; gol = același ca header */
  footerLogoUrl: "",
  /** Link-uri complete (https://…); goale = ascuns (Instagram poate folosi încă @ din „Instagram”) */
  socialInstagramUrl: "",
  socialFacebookUrl: "",
  socialTiktokUrl: "",
  socialLinkedinUrl: "",
};
